import { render, staticRenderFns } from "./selectedDate.vue?vue&type=template&id=38d4fe32&scoped=true"
import script from "./selectedDate.vue?vue&type=script&lang=js"
export * from "./selectedDate.vue?vue&type=script&lang=js"
import style0 from "./selectedDate.vue?vue&type=style&index=0&id=38d4fe32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4fe32",
  null
  
)

export default component.exports